import { ComponentWithPermissions } from '../../../../../../../../baseComponents/CreateRoutering/types'
import TwinFileSystem from '../../../../../../../../baseComponents/TwinFileSystem'
import { SupplierModelType } from '@teinor/erp/types/company/supplier'

interface CreditorFilesProps extends ComponentWithPermissions {
    basicData: SupplierModelType | null
}

const CreditorFiles: React.FC<CreditorFilesProps> = ({ userPermissions, basicData }) => {
    if (basicData?.id) {
        return (<TwinFileSystem subFolder={'/' + basicData.id+'/creditorFolder'} type='creditor' userPermissions={userPermissions}></TwinFileSystem>)
    }
    return null
}

export default CreditorFiles